function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import ReactTooltip from "react-tooltip";
import ShowBigger from "@common/components/show-bigger/ShowBigger";
import Show from "@common/components/show/Show";
import VodCard from "@common/components/vod-card/VodCard";
import { isMobile } from "@common/services/helpers";
import { BACK_LINK_HEIGHT, ROUTE_ON_RECORD_PAGE_SIZE, SHOW_BIG_ITEM_HEIGHT, SHOW_ITEM_HEIGHT, SHOW_ITEM_HEIGHT_LOW_RESOLUTION, TABLET_TYPE_PX, TOOLTIP_SHOW_DELAY, VOD } from "@config/constants";
var BOTTOM_OFFSET = 60; // the request will be made when scroll enters this zone
var ITEM_WIDTH_LARGE = 228; // >= 768px: 208px width + 2*10px margin
var ITEM_WIDTH_SMALL = 157; // < 768px: 137px width + 2*10px margin
var BIG_ITEM_WIDTH_LARGE = 296; // >= 768px: 276px; width + 2*10px margin
var HEADER_HEIGHT_BIG = 115; // < 768px
var HEADER_HEIGHT_SMALL = 60; // >= 768px
var MIN_SCROLL_TO_RECOUNT = 150; // pixels to be scrolled before recounting
var RESPONSIVE_BREAKPOINT = 768; // the width under which the show width changes
var ADDITIONAL_ROWS_TO_RENDER = 3;
var VerticalInfiniteScroll = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(VerticalInfiniteScroll, PureComponent);
    var _super = _create_super(VerticalInfiniteScroll);
    function VerticalInfiniteScroll(props) {
        _class_call_check(this, VerticalInfiniteScroll);
        var _this;
        _this = _super.call(this, props);
        _this.el = null;
        _this.scrollTarget = null;
        _this.currentScrollTop = 0;
        _this.currentScrollTopBreakpoint = 0;
        _this.isFetching = false;
        _this.onceReachedBottom = false;
        _this.isLastPage = false;
        _this.state = {
            compensatorAfterHeight: 0,
            compensatorBeforeHeight: 0,
            visibleContent: []
        };
        _this.recount = _this.recount.bind(_assert_this_initialized(_this));
        _this.scrollHandler = _this.scrollHandler.bind(_assert_this_initialized(_this));
        _this.resizeHandler = _this.resizeHandler.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(VerticalInfiniteScroll, [
        {
            /**
     * Returns an array of Show components to be rendered.
     * @returns {Array<Show> || null}
     */ key: "renderVisibleContent",
            value: function renderVisibleContent() {
                var _this_props = this.props, channelsLogos = _this_props.channelsLogos, hasLogo = _this_props.hasLogo, history = _this_props.history, i18n = _this_props.i18n, isCardBig = _this_props.isCardBig, isCardWithoutHeader = _this_props.isCardWithoutHeader, showCategories = _this_props.showCategories, showHasLabel = _this_props.showHasLabel, type = _this_props.type;
                var visibleContent = this.state.visibleContent;
                var template = null;
                if (Array.isArray(visibleContent)) {
                    template = visibleContent.map(function(show) {
                        var chanId = show.chanId, start = show.start, stop = show.stop, title = show.title;
                        // Define unique key for each show using
                        // it's title and start timestamp.
                        var key = "".concat(title, "-").concat(start, "-").concat(stop, "-").concat(chanId);
                        var componentProps = {
                            className: "margin-bottom-med",
                            logo: channelsLogos[chanId],
                            i18n: i18n,
                            hasLogo: hasLogo,
                            history: history,
                            showCategories: showCategories,
                            showHasLabel: showHasLabel,
                            key: key,
                            show: show,
                            isCardWithoutHeader: isCardWithoutHeader,
                            type: type,
                            photos: show.photos
                        };
                        if (type === VOD) return /*#__PURE__*/ _jsx(VodCard, _object_spread({}, componentProps));
                        return isCardBig ? /*#__PURE__*/ _jsx(ShowBigger, _object_spread({}, componentProps)) : /*#__PURE__*/ _jsx(Show, _object_spread({}, componentProps));
                    });
                }
                return template;
            }
        },
        {
            /**
     * Determines the heights of the 'before' and 'after'
     * compensating divs and also the array shows to be rendered
     * based on the current content length, the width of the container
     * and the corresponding dimensions of a Show element.
     */ key: "recount",
            value: function recount() {
                var _this_props = this.props, content = _this_props.content, isCardBig = _this_props.isCardBig;
                if (content.length === 0) {
                    return;
                }
                var offsetWidth = this.el.offsetWidth;
                var itemWidth;
                var showItemHeight;
                var headerHeight = window.innerWidth < RESPONSIVE_BREAKPOINT ? HEADER_HEIGHT_BIG : HEADER_HEIGHT_SMALL;
                if (isCardBig) {
                    itemWidth = BIG_ITEM_WIDTH_LARGE;
                    showItemHeight = SHOW_BIG_ITEM_HEIGHT;
                } else {
                    itemWidth = window.innerWidth < RESPONSIVE_BREAKPOINT ? ITEM_WIDTH_SMALL : ITEM_WIDTH_LARGE;
                    showItemHeight = window.innerWidth <= TABLET_TYPE_PX ? SHOW_ITEM_HEIGHT_LOW_RESOLUTION : SHOW_ITEM_HEIGHT;
                }
                var visibleHeight = window.innerHeight - headerHeight;
                var elementsPerRow = offsetWidth / itemWidth;
                var numberOfRows = Math.ceil(content.length / elementsPerRow);
                //  1 is added because we can have for example 3 full
                // visible rows and + 2 semi rows which sum to 4 as total height.
                var maxNumberOvVisibleRows = Math.ceil(visibleHeight / showItemHeight) + 1;
                // Add additional rows to have more smooth experience
                // when scrolling fast ot less powerful devices.
                var numberOfRenderedRows = maxNumberOvVisibleRows + ADDITIONAL_ROWS_TO_RENDER;
                // Render all if the first page is also the last page.
                if (content.length > 0 && content.length < ROUTE_ON_RECORD_PAGE_SIZE) {
                    this.isLastPage = true;
                    numberOfRenderedRows = numberOfRows;
                }
                // We can't have more rendered rows than 'numberOfRows'.
                numberOfRenderedRows = Math.min(numberOfRenderedRows, numberOfRows);
                // So the maximum invisible rows before can be.
                var maxBeforeInvisibleRows = numberOfRows - numberOfRenderedRows;
                // Make sure to have at least 2 rendered rows
                // in the not visible area
                // (the 3rd additional row is left for the after area).
                var compensatedScrollTop = Math.max(this.currentScrollTop - (BACK_LINK_HEIGHT + 2 * showItemHeight), 0);
                // So only when the scrollTop reaches the
                // bottom of the third row, set the first
                // before invisible row:
                var calculatedBeforeInvisibleRows = Math.floor(compensatedScrollTop / showItemHeight);
                // On reaching the bottom the browser can get
                // elastic and over-scroll, which leads to
                // incorrect (higher) numbers for the calculated
                // before invisible rows. So here their number
                // is limited to the maximal possible number.
                var numberOfBeforeInvisibleRows = Math.min(calculatedBeforeInvisibleRows, maxBeforeInvisibleRows);
                // Then the indexes of the first and the last
                // elements to be rendered is determined.
                var indexOfFirstVisible = numberOfBeforeInvisibleRows * elementsPerRow;
                var compensatorBeforeHeight = numberOfBeforeInvisibleRows * showItemHeight;
                var indexOfLastVisible = indexOfFirstVisible + (numberOfRenderedRows * elementsPerRow - 1);
                // The remaining rows are assigned to the
                // after invisible rows container.
                var numberOfAfterInvisibleRows = Math.max(numberOfRows - numberOfBeforeInvisibleRows - numberOfRenderedRows, 0);
                var compensatorAfterHeight = numberOfAfterInvisibleRows * showItemHeight;
                this.setState({
                    compensatorAfterHeight: compensatorAfterHeight,
                    compensatorBeforeHeight: compensatorBeforeHeight,
                    // slice doesn't take the last index,
                    // so we ad 1 here to get it:
                    visibleContent: content.slice(indexOfFirstVisible, indexOfLastVisible + 1)
                });
            }
        },
        {
            /**
     * Determines on what conditions to recount
     * or to get a next page.
     * @param target {Element}
     */ key: "scrollHandler",
            value: function scrollHandler(param) {
                var target = param.target;
                // Get reference to the scroll target
                // in order to be able to set it's
                // scrollTop property in other parts
                // of the code.
                if (this.scrollTarget === null) {
                    this.scrollTarget = target;
                }
                var _this_props = this.props, category = _this_props.category, content = _this_props.content, getPage = _this_props.getPage;
                var scrollY = window.scrollY;
                var _document_documentElement = document.documentElement, scrollHeight = _document_documentElement.scrollHeight, clientHeight = _document_documentElement.clientHeight;
                var maxScrollY = scrollHeight - clientHeight;
                if (!isMobile.any()) {
                    scrollY = this.scrollTarget.scrollTop;
                    scrollHeight = this.scrollTarget.scrollHeight;
                    clientHeight = this.scrollTarget.clientHeight;
                    maxScrollY = scrollHeight - clientHeight;
                }
                this.currentScrollTop = Number.parseInt(scrollY);
                // After several pixels scrolled, recount visible elements.
                var scrolledEnoughForRecount = Math.abs(this.currentScrollTop - this.currentScrollTopBreakpoint) >= MIN_SCROLL_TO_RECOUNT;
                if (scrolledEnoughForRecount) {
                    this.currentScrollTopBreakpoint = this.currentScrollTop;
                    this.recount();
                }
                // On reaching the bottom request the next page,
                // but only if there is a current content,
                // because otherwise sometimes it makes
                // a call for the initial page, before the props are set.
                var hasContent = this.props.content.length > 0;
                var bottomReached = this.currentScrollTop >= maxScrollY - BOTTOM_OFFSET;
                if (hasContent && bottomReached && !this.isFetching && !this.isLastPage) {
                    this.isFetching = true;
                    // Used when determining if the current page
                    // is the last one (see 'componentDidUpdate').
                    this.onceReachedBottom = true;
                    typeof getPage === "function" && getPage(category.id, content.length, ROUTE_ON_RECORD_PAGE_SIZE);
                }
            }
        },
        {
            /**
     * Recounts on resizing.
     * @param event
     */ key: "resizeHandler",
            value: function resizeHandler(event) {
                this.recount();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var screenType = this.props.screenType;
                var _this_state = this.state, compensatorAfterHeight = _this_state.compensatorAfterHeight, compensatorBeforeHeight = _this_state.compensatorBeforeHeight;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "vertical-infinite-scroll-component-2",
                    ref: function(el) {
                        return _this.el = el;
                    },
                    children: [
                        /*#__PURE__*/ _jsx(ReactTooltip, {
                            id: "show-slider-tooltip",
                            className: "tooltip",
                            place: "bottom",
                            delayShow: TOOLTIP_SHOW_DELAY,
                            effect: "solid",
                            disable: !screenType.web
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "compensator-before",
                            style: {
                                height: compensatorBeforeHeight
                            }
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "visible-content",
                            children: this.renderVisibleContent()
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "compensator-after",
                            style: {
                                height: compensatorAfterHeight
                            }
                        })
                    ]
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                window.addEventListener("scroll", this.scrollHandler, true);
                window.addEventListener("resize", this.resizeHandler, false);
                this.recount();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState, prevContext) {
                if (prevProps.content !== this.props.content) {
                    // So if the bottom has been reached at least once
                    // (so a request has been made) and the content
                    // length hasn't changed, an assumption is made that
                    // the last page has been reached.
                    var emptyResponse = prevProps.content.length === this.props.content.length;
                    if (emptyResponse && this.onceReachedBottom) {
                        this.isLastPage = true;
                    }
                    // If the content has changed it means that
                    // fetching has finished.
                    this.isFetching = false;
                    this.recount();
                }
                ReactTooltip.rebuild();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("scroll", this.scrollHandler, true);
                window.removeEventListener("resize", this.resizeHandler, false);
            }
        }
    ]);
    return VerticalInfiniteScroll;
}(PureComponent);
export default VerticalInfiniteScroll;
